import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface TreatmentPlanMeta {
  data: any;
  patientName: any;
  doctorName: any;
  idPDT: number;
  id: number;
  typePDT: 'ALIGNEUR' | 'BIBAGUE' | 'RCC' | 'PDT' | 'CR';
  idPatient: number;
  idDocteur: number;
  prisPar: number | null;
  executerPar: number | null;
  sendBy: number | null;
  status: 'RECU' | 'ANNULER' | 'EN_COURS' | 'EXPEDIER';
  commentaire: string | null;
  commentaireDocteur: string | null;
  recuLe: string | null;
  poseLe: string | null;
  date: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class TreatmentPlanMetaService {
  private readonly apiUrl = environment.apiUrl;
  private readonly baseUrl = `${this.apiUrl}treatment-plan-meta`;

  constructor(private http: HttpClient) { }

  // -------------------------------------------------------
  // GET all
  // -------------------------------------------------------
  getAll(): Observable<TreatmentPlanMeta[]> {
    return this.http.get<TreatmentPlanMeta[]>(`${this.baseUrl}`);
  }



  // -------------------------------------------------------
  // UPDATE status
  // -------------------------------------------------------
  updateStatus(id: number, status: TreatmentPlanMeta['status']): Observable<TreatmentPlanMeta> {
    const body = { status };
    // Backend contract: PUT /treatment-plan-meta/{id}/status
    return this.http.put<TreatmentPlanMeta>(`${this.baseUrl}/${id}/status`, body);
  }

  // -------------------------------------------------------
  // UPDATE commentaire
  // -------------------------------------------------------
  updateComment(id: number, commentaire: string): Observable<TreatmentPlanMeta> {
    return this.http.put<TreatmentPlanMeta>(`${this.baseUrl}/${id}/commentaire`, { commentaire });
  }

  // -------------------------------------------------------
  // UPDATE
  // -------------------------------------------------------
  update(id: number, payload: TreatmentPlanMeta): Observable<TreatmentPlanMeta> {
    console.log('id', id);
    console.log('payload', payload);

    return this.http.put<TreatmentPlanMeta>(`${this.baseUrl}/${id}`, payload);
  }

  // -------------------------------------------------------
  // DELETE
  // -------------------------------------------------------
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  // -------------------------------------------------------
  // GET by Patient
  // -------------------------------------------------------
  getByPatient(idPatient: number): Observable<TreatmentPlanMeta[]> {
    return this.http.get<TreatmentPlanMeta[]>(`${this.baseUrl}/patient/${idPatient}`);
  }

  // -------------------------------------------------------
  // GET by Doctor
  // -------------------------------------------------------
getByDoctor(idDoctor?: number | null): Observable<TreatmentPlanMeta[]> {
  let url = `${this.baseUrl}/doctor`;
  if (idDoctor) {
    url += `?idDocteur=${idDoctor}`;
  }
  return this.http.get<TreatmentPlanMeta[]>(url);
}

  // -------------------------------------------------------
  // GET by Status (RECU, ANNULER, EN_COURS, EXPEDIER)
  // -------------------------------------------------------
  getByStatus(status: string): Observable<TreatmentPlanMeta[]> {
    return this.http.get<TreatmentPlanMeta[]>(`${this.baseUrl}/status/${status}`);
  }

  // -------------------------------------------------------
  // GET by Type (ALIGNEUR, BIBAGUE, RCC, PDT, CR)
  // -------------------------------------------------------
  getByType(type: string): Observable<TreatmentPlanMeta[]> {
    return this.http.get<TreatmentPlanMeta[]>(`${this.baseUrl}/type/${type}`);
  }


  getOneById(id: any): Observable<TreatmentPlanMeta[]> {
    return this.http.get<TreatmentPlanMeta[]>(`${this.baseUrl}/one/${id}`);
  }



  getListPlanDeTraitementByLabo(idPatient: number) {
    return this.http.get<TreatmentPlanMeta[]>(
      `${this.apiUrl}treatment-plan-meta/executer/${idPatient}`
    );
  }

  getListPlanDeTraitementByDoctor(idDocteur: number) {
    return this.http.get<TreatmentPlanMeta[]>(
      `${this.baseUrl}/doctor/${idDocteur}`
    );
  }

    addPlanDeTraitementComment(comment: any) {
    return this.http.post<TreatmentPlanMeta>(`${this.baseUrl}/commentaire`, comment);
  }

  /**
   * GET enriched plan by doctor and plan ID
   * Returns List<TreatmentPlanMeta>
   */
  getByDoctorAndId(idDocteur: number, id: number): Observable<TreatmentPlanMeta[]> {
    return this.http.get<TreatmentPlanMeta[]>(`${this.baseUrl}/doctor/${idDocteur}/id/${id}`);
  }





}
